import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const GridIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 6.2V9.8C5 10.5 5.5 11 6.2 11H9.8C10.5 11 11 10.5 11 9.8V6.2C11 5.5 10.5 5 9.8 5H6.2C5.5 5 5 5.5 5 6.2ZM5 14.2V17.8C5 18.5 5.5 19 6.2 19H9.8C10.5 19 11 18.5 11 17.8V14.2C11 13.5 10.5 13 9.8 13H6.2C5.5 13 5 13.5 5 14.2ZM13 9.8V6.2C13 5.5 13.5 5 14.2 5H17.8C18.5 5 19 5.5 19 6.2V9.8C19 10.5 18.5 11 17.8 11H14.2C13.5 11 13 10.5 13 9.8ZM13 14.2V17.8C13 18.5 13.5 19 14.2 19H17.8C18.5 19 19 18.5 19 17.8V14.2C19 13.5 18.5 13 17.8 13H14.2C13.5 13 13 13.5 13 14.2Z"
      />
    </Icon>
  );
};
